export default __webpack_public_path__ + "static/banner-renovation-easy-ways-to-add-character-to-your-home-220257740151e814e5c4f5bce18fda02.jpg";